import { Map } from 'immutable';

import { ADD_TO_CANCEL_SUBSCRIPTION } from './types';

const initialState = Map({
  subscriptionToCancel: {},
});

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case ADD_TO_CANCEL_SUBSCRIPTION:
      return state.set('subscriptionToCancel', payload);
    default:
      return state;
  }
};
